<div class="start-transport-pause-dialog mat-body">

  <div class="dialog-layout">

    <h2 class="dialog-h2">
      <sc-dictionary-label dictionaryKey="tmc.visit.overview.start-transport-pause-dialog.title"></sc-dictionary-label>
    </h2>


    <div class="top-info">
      <app-transport-info-panel [carrier]="data.carrier" [identifier]="data.identifier" [driver]="data.name"
        [scope]="data.transportScope"></app-transport-info-panel>
    </div>

    <div class="dialog-content">
      <mat-form-field class="end-time" appearance="fill">
        <mat-label>
          <sc-dictionary-label dictionaryKey="tmc.visit.overview.start-transport-pause-dialog.end"></sc-dictionary-label>
        </mat-label>
        <input matInput
          [(ngModel)]="end" type="datetime-local">
      </mat-form-field>

      <app-dictionary-key-select [selectedIndex]="0" (selectionChanged)="optionsChanged($event)"
        label="{{'select cause' | translate: ['tmc.visit.overview.start-transport-pause-dialog.cause.title', translationService.language, translationService.revision]}}"
        [rootKey]="'tmc.visit.overview.start-transport-pause-dialog.cause.options'" [required]="true">
      </app-dictionary-key-select>

      <mat-form-field class="textarea-note" appearance="fill">
        <mat-label>
          <sc-dictionary-label dictionaryKey="tmc.visit.overview.start-transport-pause-dialog.note"></sc-dictionary-label>
        </mat-label>
        <textarea
          matInput [(ngModel)]="note" [required]="cps.isPropertyTrue('visitoverview.delete.length.cause', false)"
          [maxlength]="9999" cdkTextareaAutosize cdkAutosizeMinRows="5" cdkAutosizeMaxRows="15">
        </textarea>
      </mat-form-field>

      <app-service-response [responseMessages]="responseMessages"></app-service-response>
    </div>



    <sc-actionbar>
      <sc-content-spacer grow></sc-content-spacer>
      <sc-cancel-button class="cancel-button" (click)="cancelDialog()" [disabled]="isCancelDisabled()" dictionaryKey="shared.selection-dialog.action.cancel"></sc-cancel-button>
      <sc-content-spacer></sc-content-spacer>
      <button mat-flat-button class="confirm-button" (click)="confirm()" [disabled]="isConfirmDisabled()">
        <sc-dictionary-label dictionaryKey="tmc.visit.overview.start-transport-pause-dialog.button.start"></sc-dictionary-label>
      </button>
    </sc-actionbar>
  </div>
</div>
